import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';

/**
 * Description
 * @param {object} props
 * @param {object} props.primaryBillingPoint
 * @returns {React.ReactComponentElement} - AdminPropertyShowPrimaryBillingPoint component
 */
function AdminPropertyShowPrimaryBillingPoint({ primaryBillingPoint = null }) {
  if (!primaryBillingPoint) {
    return <Loading />;
  }

  const { uuid, identifier, active } = primaryBillingPoint;

  return (
    <tr>
      <th scope="row" colSpan={2}>
        <Link to={`/admin/primary-billing-points/${uuid}`}>
          {identifier}
        </Link>
        <br />
        <UUID uuid={uuid} />
      </th>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
    </tr>
  );
}

AdminPropertyShowPrimaryBillingPoint.propTypes = {
  primaryBillingPoint: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default AdminPropertyShowPrimaryBillingPoint;
